import { render, staticRenderFns } from "./ItemIntegrationDialog.vue?vue&type=template&id=035cdb44&scoped=true&"
import script from "./ItemIntegrationDialog.vue?vue&type=script&lang=js&"
export * from "./ItemIntegrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ItemIntegrationDialog.vue?vue&type=style&index=0&id=035cdb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cdb44",
  null
  
)

export default component.exports